module.exports = __webpack_public_path__ + "static/Q1_2026_Material_Differences_Report-3f5973b9cd489cf9503d7eb83e7f086f.pdf";